import * as bootstrap from 'bootstrap';
import GLightbox from 'glightbox';
import Swiper from 'swiper/bundle';
import Helper from './helper';

import 'swiper/css/bundle';

import.meta.glob([
    '../img/**'
]);

class App {
    constructor() {
        this.init();
    }

    init() {
        this.navbarCollapse();
        this.asyncForms();
        this.productSlider();
        this.timelineSlider();
        this.photoSlider();
        this.cardSlider();
        this.map();
        this.cookies();
        this.initGLightbox();
    }

    navbarCollapse() {
        const navbarCollapse = document.getElementById('navbar');

        if (navbarCollapse === null) {
            return false;
        }

        navbarCollapse.addEventListener('show.bs.collapse', event => {
            document.body.classList.add('navbar-collapse-open');
        });

        navbarCollapse.addEventListener('hide.bs.collapse', event => {
            document.body.classList.remove('navbar-collapse-open');
        });
    }

    /**
     * Process asynchronous forms
     */
    asyncForms() {
        const refreshTurnstile = form => {
            const widget = form.querySelector('.turnstile-widget');

            if (widget && widget.dataset.widgetId && typeof turnstile !== 'undefined') {
                turnstile.reset(widget.dataset.widgetId);
            }
        };

        document.querySelectorAll('.form--async').forEach(form => {
            form.addEventListener('submit', (e) => {
                e.preventDefault();

                // Serialize all form data
                let formData = new FormData(form);

                // Fetch container for the form messages
                let formMessages = form.querySelector('.form-messages');

                // Clear the form errors
                form.querySelectorAll('[data-error]').forEach(errorMessage => {
                    // Clear error message
                    errorMessage.innerHTML = '';

                    // Remove multiple status class
                    errorMessage.classList.remove('multiple');
                });

                // Clear the form messages
                formMessages.replaceChildren();

                Helper.post(form.getAttribute('action'), formData).then(response => {
                    if (response.redirect_url) {
                        // Redirect to the given URL
                        window.location.href = response.redirect_url;
                    }
                    else {
                        // Reset form
                        form.reset();

                        // Generate a fresh token for the next submission
                        refreshTurnstile(form);

                        formMessages.innerHTML = '<div class="alert alert--' + response.message.type + '"><span>' + response.message.text + '</span></div>';
                    }
                })
                .catch(error => {
                    let statusCode = error.statusCode;

                    switch (statusCode) {
                        case 422:
                            // Set error messages
                            Object.entries(error.response.errors).forEach(([key, errors]) => {
                                // Find the target element with data-error attribute
                                const targetElement = form.querySelector('[data-error="' + key + '"]');

                                if (targetElement === null) {
                                    return;
                                }

                                if (errors.length > 1) {
                                    // Mark container as multiple errors
                                    targetElement.classList.add('multiple');
                                }

                                errors.forEach(function (error) {
                                    // Create a new <span> element
                                    const errorSpan = document.createElement('span');

                                    // Set the text content of the <span>
                                    errorSpan.textContent = error;

                                    // Append the <span> as a child of the target element
                                    targetElement.appendChild(errorSpan);
                                });
                            });
                            break;

                        default:
                            // Show notification
                            alert('Er is iets misgegaan.');
                    }

                    // Tokens are single-use, including when another field fails validation
                    refreshTurnstile(form);

                    // Reject the promise
                    return Promise.reject(error.statusText);
                });
            });
        });
    }

    productSlider() {
        document.querySelectorAll('.products__photos').forEach(photosElement => {
            const productItem = photosElement.closest('.products__item');
            const thumbnailsElement = productItem.querySelector('.products__thumbnails');
            const thumbnailElementButtons = Array.from(thumbnailsElement.querySelectorAll('.products__thumbnails-item'));

            const photoSwiper = new Swiper(photosElement, {
                autoplay: false,
                loop: true,
                spaceBetween: 15,
                slidesPerView: 1,
                slidesPerGroup: 1
            });

            const thumbnailSwiper = new Swiper(thumbnailsElement, {
                loop: false,
                spaceBetween: 5,
                slidesPerView: 10,
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });

            function setActiveThumbnail(realIndex) {
                thumbnailElementButtons.forEach(btn => btn.classList.remove('products__thumbnails--active'));

                const btn = thumbnailElementButtons[realIndex];

                if (btn) {
                    btn.classList.add('products__thumbnails--active');
                }

                thumbnailSwiper.slideTo(realIndex);
            }

            // On photo slide change -> update active thumbnail
            photoSwiper.on('slideChange', () => {
                setActiveThumbnail(photoSwiper.realIndex);
            });

            // Click thumbnail -> go to corresponding photo slide
            thumbnailElementButtons.forEach((btn, index) => {
                btn.addEventListener('click', () => {
                    photoSwiper.slideToLoop(index);

                    setActiveThumbnail(index);
                });
            });

            // Init active state
            setActiveThumbnail(photoSwiper.realIndex);
        });

        document.querySelectorAll('.cards__list').forEach(element => {
            new Swiper('#' + element.getAttribute('id'), {
                loop: true,
                autoplay: {
                    delay: 5000
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1
                    },
                    576: {
                        slidesPerView: 2
                    },
                    1200: {
                        slidesPerView: 3
                    }
                },
                spaceBetween: 15,
                slidesPerGroup: 1,
                navigation: {
                    nextEl: element.parentElement.querySelector('.cards__nav--next'),
                    prevEl: element.parentElement.querySelector('.cards__nav--previous')
                }
            });
        });
    }

    timelineSlider() {
        document.querySelectorAll('.timeline__list').forEach(element => {
            new Swiper('#' + element.getAttribute('id'), {
                loop: true,
                autoplay: {
                    delay: 5000
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 30
                    },
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    },
                    992: {
                        slidesPerView: 4,
                        spaceBetween: 30
                    },
                    1600: {
                        slidesPerView: 4,
                        spaceBetween: 50
                    }
                },
                slidesPerGroup: 1
            });
        });
    }

    photoSlider() {
        document.querySelectorAll('.photos__list').forEach(element => {
            new Swiper('#' + element.getAttribute('id'), {
                loop: true,
                autoplay: {
                    delay: 5000
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1
                    },
                    768: {
                        slidesPerView: 2
                    },
                    1200: {
                        slidesPerView: 'auto'
                    }
                },
                centeredSlides: true,
                spaceBetween: 15,
                slidesPerGroup: 1,
                navigation: {
                    nextEl: element.parentElement.querySelector('.photos__nav--next'),
                    prevEl: element.parentElement.querySelector('.photos__nav--previous')
                }
            });
        });
    }

    cardSlider() {
        document.querySelectorAll('.cards__list').forEach(element => {
            new Swiper('#' + element.getAttribute('id'), {
                loop: true,
                autoplay: {
                    delay: 5000
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1
                    },
                    576: {
                        slidesPerView: 2
                    },
                    1200: {
                        slidesPerView: 3
                    }
                },
                spaceBetween: 15,
                slidesPerGroup: 1,
                navigation: {
                    nextEl: element.parentElement.querySelector('.cards__nav--next'),
                    prevEl: element.parentElement.querySelector('.cards__nav--previous')
                }
            });
        });
    }

    /**
     * Initialize map
     */
    map () {
        let container = document.getElementById('map');

        if (container === null) {
            return;
        }

        let osm = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
            minZoom: 4,
            maxZoom: 20
        });

        let map = new L.Map('map', {
            center: new L.LatLng(52.34829672952302, 6.660666217482625),
            scrollWheelZoom: false,
            zoom: 10
        });

        let icon = L.icon({
            iconUrl: container.dataset.urlMarker,
            iconSize: [72, 87],
        })

        L.marker([52.34829672952302, 6.660666217482625])
            .setIcon(icon)
            .addTo(map)
            .bindPopup('Bornerbroeksestraat 155<br />7601 BG Almelo');

        L.marker([52.488147133489775, 6.127500098198188])
            .setIcon(icon)
            .addTo(map)
            .bindPopup('Simon Stevinweg 13<br />8013 NA Zwolle');

        L.marker([52.252294028796456, 6.788120669353622])
            .setIcon(icon)
            .addTo(map)
            .bindPopup('Boekeloseweg 123<br />7553 DM Hengelo');

        L.marker([52.211522612546254, 5.968358300871638])
            .setIcon(icon)
            .addTo(map)
            .bindPopup('Apeldoorn');

        let controls_layer = L.control.layers({
            osm: osm.addTo(map),
            google: L.tileLayer('https://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}', {
                attribution: 'google'
            })
        }).addTo(map);

        map.removeControl(controls_layer);
    }

    /**
     * Set cookie preferences
     */
    cookies() {
        let form = document.getElementById('form-cookies');

        if (form === null) {
            return false;
        }

        // Show the cookie form
        form.classList.remove('fade');

        // Add cookie selection state
        document.body.classList.add('cookie-selection');

        let options = form.querySelector('.cookies-banner__options');

        let textChecked   = 'Alle cookies accepteren';
        let textUnchecked = 'Geselecteerde cookies accepteren'

        let buttonSubmit = form.querySelector('button[type="submit"]');

        let isAllCookiesChecked = function () {
            let checked = true;

            options.querySelectorAll('.form-check-input').forEach(switchElement => {
                if (switchElement.checked === false) {
                    checked = false;
                }
            });

            return checked;
        }

        options.querySelectorAll('.form-check-input').forEach(input => {
            // Bind the change event listener to the form check input
            input.addEventListener('change', function () {
                buttonSubmit.innerText = isAllCookiesChecked() ? textChecked : textUnchecked;
            });

            // Manually create on on-change event
            let event = new Event('change');

            // Manually dispatch event
            input.dispatchEvent(event);
        });

        const collapseCookies = document.getElementById('collapse-cookies');

        collapseCookies.addEventListener('show.bs.collapse', () => {
            collapseCookies.querySelectorAll('.form-check-input:not(#cookies-functional)').forEach(input => {
                input.checked = false;
            });

            buttonSubmit.innerText = textUnchecked;
        })

        form.addEventListener('submit', function(e) {
            e.preventDefault();

            let formData = new FormData(this);

            if (e.submitter) {
                // Manually add button name and value
                formData.append(e.submitter.name, e.submitter.value);
            }

            Helper.post(this.action, formData).then(() => {
                // Remove cookie selection state
                document.body.classList.remove('cookie-selection');

                // Fade out the form
                form.classList.add('fade');

                setTimeout(function () {
                    // Reload page
                    location.reload();
                }, 1000);
            })
            .catch(error => {
                // Reject the promise
                return Promise.reject(error.statusText);
            });
        });
    }

    initGLightbox() {
        GLightbox({
            zoomable: true
        });
    }
}

window.addEventListener('load', () => new App());
